import StudioRest from "./StudioRest"


class StudioManager extends StudioRest {}


export default StudioManager
